import React, { Component } from 'react';





class Home extends Component {




    render() {

        return (
            <div>
                <div className="page ">




                </div>
            </div>

        );
    }
}



export default Home;


// WEBPACK FOOTER //
// ./src/jsx/components/pages/home.jsx